"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var TransferErc20_1 = require("./TransferErc20");

var utils_1 = require("../utils");

var entities_1 = require("../entities");

var constants_1 = require("../utils/constants");
/**
 * Procedure that launches a Tiered STO
 */


var LaunchTieredSto =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(LaunchTieredSto, _Procedure_1$Procedur);

  function LaunchTieredSto() {
    var _this;

    _classCallCheck(this, LaunchTieredSto);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LaunchTieredSto).apply(this, arguments));
    _this.type = types_1.ProcedureType.LaunchTieredSto;
    return _this;
  }
  /**
   * - Transfer the necessary amount of POLY to the Security Token to cover the STO's setup fee
   * - Launch the Tiered STO
   * - Allow pre-issuing (if applicable, defaults to false)
   * - Return the newly created STO
   *
   * Note that this procedure will fail if:
   * - The supplied custom currency oracle addresses corresponding to the selected fund raise currencies are invalid
   * - Raising in Stable Coin and not providing stable coin addresses
   * - Attempting to allow pre-issuing on a version 3.0 STO
   */


  _createClass(LaunchTieredSto, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        var args, context, symbol, startDate, endDate, tiers, nonAccreditedInvestmentLimit, minimumInvestment, currencies, raisedFundsWallet, unsoldTokensWallet, _args$stableCoinAddre, stableCoinAddresses, customCurrency, _args$allowPreIssuing, allowPreIssuing, contractWrappers, tieredStoFactory, securityToken, customOracleAddresses, denominatedCurrency, _customCurrency$curre, currencySymbol, _customCurrency$ethOr, ethOracleAddress, _customCurrency$polyO, polyOracleAddress, securityTokenAddress, moduleName, factoryAddress, moduleFactory, usdCost, _ref, _ref2, polyCost, isCostInPoly, cost, balance, difference, ratePerTier, ratePerTierDiscountPoly, tokensPerTierTotal, tokensPerTierDiscountPoly, _ref4, _ref5, newStoAddress, newSto;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                args = this.args, context = this.context;
                symbol = args.symbol, startDate = args.startDate, endDate = args.endDate, tiers = args.tiers, nonAccreditedInvestmentLimit = args.nonAccreditedInvestmentLimit, minimumInvestment = args.minimumInvestment, currencies = args.currencies, raisedFundsWallet = args.raisedFundsWallet, unsoldTokensWallet = args.unsoldTokensWallet, _args$stableCoinAddre = args.stableCoinAddresses, stableCoinAddresses = _args$stableCoinAddre === void 0 ? [] : _args$stableCoinAddre, customCurrency = args.customCurrency, _args$allowPreIssuing = args.allowPreIssuing, allowPreIssuing = _args$allowPreIssuing === void 0 ? false : _args$allowPreIssuing;
                contractWrappers = context.contractWrappers, tieredStoFactory = context.factories.tieredStoFactory;
                _context4.prev = 3;
                _context4.next = 6;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 6:
                securityToken = _context4.sent;
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](3);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 12:
                if (!(currencies.includes(contract_wrappers_1.FundRaiseType.StableCoin) && stableCoinAddresses.length === 0)) {
                  _context4.next = 14;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'Stable Coin address array cannot be empty if raising in Stable Coin'
                });

              case 14:
                customOracleAddresses = [];
                denominatedCurrency = '';

                if (!customCurrency) {
                  _context4.next = 37;
                  break;
                }

                _customCurrency$curre = customCurrency.currencySymbol, currencySymbol = _customCurrency$curre === void 0 ? 'USD' : _customCurrency$curre, _customCurrency$ethOr = customCurrency.ethOracleAddress, ethOracleAddress = _customCurrency$ethOr === void 0 ? '' : _customCurrency$ethOr, _customCurrency$polyO = customCurrency.polyOracleAddress, polyOracleAddress = _customCurrency$polyO === void 0 ? '' : _customCurrency$polyO;

                if (!currencies.includes(contract_wrappers_1.FundRaiseType.ETH)) {
                  _context4.next = 26;
                  break;
                }

                if (utils_1.isValidAddress(ethOracleAddress)) {
                  _context4.next = 23;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "Must provide ETH oracle for '".concat(currencySymbol, "'")
                });

              case 23:
                customOracleAddresses.push(ethOracleAddress);

              case 24:
                _context4.next = 27;
                break;

              case 26:
                customOracleAddresses.push(constants_1.ZERO_ADDRESS);

              case 27:
                if (!currencies.includes(contract_wrappers_1.FundRaiseType.POLY)) {
                  _context4.next = 35;
                  break;
                }

                if (utils_1.isValidAddress(polyOracleAddress)) {
                  _context4.next = 32;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "Must provide POLY oracle for '".concat(currencySymbol, "'")
                });

              case 32:
                customOracleAddresses.push(polyOracleAddress);

              case 33:
                _context4.next = 36;
                break;

              case 35:
                customOracleAddresses.push(constants_1.ZERO_ADDRESS);

              case 36:
                denominatedCurrency = currencySymbol;

              case 37:
                _context4.next = 39;
                return securityToken.address();

              case 39:
                securityTokenAddress = _context4.sent;
                moduleName = contract_wrappers_1.ModuleName.UsdTieredSTO;
                _context4.next = 43;
                return contractWrappers.getModuleFactoryAddress({
                  tokenAddress: securityTokenAddress,
                  moduleName: moduleName
                });

              case 43:
                factoryAddress = _context4.sent;
                _context4.next = 46;
                return contractWrappers.moduleFactory.getModuleFactory(factoryAddress);

              case 46:
                moduleFactory = _context4.sent;
                usdCost = null;
                _context4.next = 50;
                return Promise.all([moduleFactory.setupCostInPoly(), moduleFactory.isCostInPoly(), moduleFactory.setupCost()]);

              case 50:
                _ref = _context4.sent;
                _ref2 = _slicedToArray(_ref, 3);
                polyCost = _ref2[0];
                isCostInPoly = _ref2[1];
                cost = _ref2[2];

                if (!isCostInPoly) {
                  usdCost = cost;
                }

                _context4.next = 58;
                return contractWrappers.polyToken.balanceOf({
                  owner: securityTokenAddress
                });

              case 58:
                balance = _context4.sent;
                difference = polyCost.minus(balance); // only transfer the required amount of POLY

                if (!difference.gt(new contract_wrappers_1.BigNumber(0))) {
                  _context4.next = 63;
                  break;
                }

                _context4.next = 63;
                return this.addProcedure(TransferErc20_1.TransferErc20)({
                  receiver: securityTokenAddress,
                  amount: difference
                });

              case 63:
                ratePerTier = [];
                ratePerTierDiscountPoly = [];
                tokensPerTierTotal = [];
                tokensPerTierDiscountPoly = [];
                tiers.forEach(function (_ref3) {
                  var tokensOnSale = _ref3.tokensOnSale,
                      price = _ref3.price,
                      _ref3$tokensWithDisco = _ref3.tokensWithDiscount,
                      tokensWithDiscount = _ref3$tokensWithDisco === void 0 ? new contract_wrappers_1.BigNumber(0) : _ref3$tokensWithDisco,
                      _ref3$discountedPrice = _ref3.discountedPrice,
                      discountedPrice = _ref3$discountedPrice === void 0 ? new contract_wrappers_1.BigNumber(0) : _ref3$discountedPrice;
                  ratePerTier.push(price);
                  ratePerTierDiscountPoly.push(discountedPrice);
                  tokensPerTierTotal.push(tokensOnSale);
                  tokensPerTierDiscountPoly.push(tokensWithDiscount);
                });
                _context4.next = 70;
                return this.addTransaction(securityToken.addModuleWithLabel, {
                  tag: types_1.PolyTransactionTag.EnableTieredSto,
                  fees: {
                    usd: usdCost,
                    poly: polyCost
                  },
                  resolvers: [function (receipt) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee() {
                      var logs, _utils_1$findEvents, _utils_1$findEvents2, event, eventArgs, _module;

                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              logs = receipt.logs;
                              _utils_1$findEvents = utils_1.findEvents({
                                eventName: contract_wrappers_1.SecurityTokenEvents.ModuleAdded,
                                logs: logs
                              }), _utils_1$findEvents2 = _slicedToArray(_utils_1$findEvents, 1), event = _utils_1$findEvents2[0];

                              if (!event) {
                                _context.next = 6;
                                break;
                              }

                              eventArgs = event.args;
                              _module = eventArgs._module;
                              return _context.abrupt("return", _module);

                            case 6:
                              throw new PolymathError_1.PolymathError({
                                code: types_1.ErrorCode.UnexpectedEventLogs,
                                message: "The Tiered STO was successfully launched but the corresponding event wasn't fired. Please report this issue to the Polymath team."
                              });

                            case 7:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));
                  }, function (receipt) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee2() {
                      var logs, _utils_1$findEvents3, _utils_1$findEvents4, event, eventArgs, _module;

                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              logs = receipt.logs;
                              _utils_1$findEvents3 = utils_1.findEvents({
                                eventName: contract_wrappers_1.SecurityTokenEvents.ModuleAdded,
                                logs: logs
                              }), _utils_1$findEvents4 = _slicedToArray(_utils_1$findEvents3, 1), event = _utils_1$findEvents4[0];

                              if (!event) {
                                _context2.next = 6;
                                break;
                              }

                              eventArgs = event.args;
                              _module = eventArgs._module;
                              return _context2.abrupt("return", tieredStoFactory.fetch(entities_1.TieredSto.generateId({
                                securityTokenId: entities_1.SecurityToken.generateId({
                                  symbol: symbol
                                }),
                                stoType: types_1.StoType.Tiered,
                                address: _module
                              })));

                            case 6:
                              throw new PolymathError_1.PolymathError({
                                code: types_1.ErrorCode.UnexpectedEventLogs,
                                message: "The Tiered STO was successfully launched but the corresponding event wasn't fired. Please report this issue to the Polymath team."
                              });

                            case 7:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));
                  }]
                })({
                  moduleName: moduleName,
                  address: factoryAddress,
                  data: {
                    startTime: startDate,
                    endTime: endDate,
                    ratePerTier: ratePerTier,
                    ratePerTierDiscountPoly: ratePerTierDiscountPoly,
                    tokensPerTierTotal: tokensPerTierTotal,
                    tokensPerTierDiscountPoly: tokensPerTierDiscountPoly,
                    nonAccreditedLimitUSD: nonAccreditedInvestmentLimit,
                    minimumInvestmentUSD: minimumInvestment,
                    fundRaiseTypes: currencies,
                    wallet: raisedFundsWallet,
                    treasuryWallet: unsoldTokensWallet,
                    stableTokens: stableCoinAddresses,
                    customOracleAddresses: customOracleAddresses,
                    denominatedCurrency: denominatedCurrency
                  },
                  maxCost: polyCost,
                  archived: false
                });

              case 70:
                _ref4 = _context4.sent;
                _ref5 = _slicedToArray(_ref4, 2);
                newStoAddress = _ref5[0];
                newSto = _ref5[1];

                if (!allowPreIssuing) {
                  _context4.next = 77;
                  break;
                }

                _context4.next = 77;
                return this.addTransaction({
                  futureValue: newStoAddress,
                  futureMethod: function futureMethod(address) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee3() {
                      var stoModule;
                      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              _context3.next = 2;
                              return contractWrappers.moduleFactory.getModuleInstance({
                                name: contract_wrappers_1.ModuleName.UsdTieredSTO,
                                address: address
                              });

                            case 2:
                              stoModule = _context3.sent;

                              if (!contract_wrappers_1.isUSDTieredSTO_3_0_0(stoModule)) {
                                _context3.next = 5;
                                break;
                              }

                              throw new PolymathError_1.PolymathError({
                                code: types_1.ErrorCode.IncorrectVersion,
                                message: 'STO version is 3.0.0. Version 3.1.0 or greater is required for pre-issuing'
                              });

                            case 5:
                              return _context3.abrupt("return", stoModule.allowPreMinting);

                            case 6:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3);
                    }));
                  }
                }, {
                  tag: types_1.PolyTransactionTag.AllowPreMinting,
                  resolvers: [function () {
                    return tieredStoFactory.update(entities_1.TieredSto.generateId({
                      securityTokenId: entities_1.SecurityToken.generateId({
                        symbol: symbol
                      }),
                      stoType: types_1.StoType.Tiered,
                      address: newStoAddress.result
                    }), {
                      preIssueAllowed: true
                    });
                  }]
                })({});

              case 77:
                return _context4.abrupt("return", newSto);

              case 78:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 9]]);
      }));
    }
  }]);

  return LaunchTieredSto;
}(Procedure_1.Procedure);

exports.LaunchTieredSto = LaunchTieredSto;